export enum AccessAccountTableAccessor {
  Name = 'name',
  Status = 'status',
  Date = 'date',
  ID = 'id',
  Action = 'action',
}
